import React, { useState } from "react";
import type { ApolloClient } from "@apollo/client";
import { toast } from "react-toastify";

import Button from "components/Button";
import { getReportCSV } from "services/adminService";
import { downloadCSVFromString } from "utils/dom";

interface Props {
  client: ApolloClient<object>;
  reportId: string;
  feeMonth?: string;
}

const FeeReportDownload = ({ client, reportId, feeMonth }: Props) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async () => {
    setIsDownloading(true);
    try {
      const csvString = await getReportCSV(client, reportId);
      downloadCSVFromString(
        csvString,
        `MonthlyAccountServiceFeeReport-${feeMonth || reportId}.csv`
      );
    } catch {
      toast.error("Unable to download the fee report.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      btnLabel="Download Fee Report"
      name="action"
      color="action"
      size="sm"
      type="button"
      loading={isDownloading}
      onClick={() => {
        void download();
      }}
    />
  );
};

export default FeeReportDownload;
